// Arrow Icon:
// Next Arrow (>) icon.

import React from 'react'
import theme from '../../../gatsby-plugin-theme-ui'

const Next = () => (
  <svg width="32px" viewBox="0 0 22.63 16.36">
    <polyline points="0.01 9.25 20.47 9.14 20.46 7.14 0 7.25" />
    <polygon points="13.88 16.36 12.51 14.9 19.7 8.15 12.44 1.47 13.8 0 22.63 8.13 13.88 16.36" />
  </svg>
)

export default Next
